/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { InfoItem } from '@molecules';

import ItemFooter from '../ItemFooter';

const Item = ({ module, previewImg, errors }) => {
  return (
    <InfoItem.WithError
      description={module.content.title}
      day={module.content.dayNumber}
      image={previewImg}
      error={errors}
      size="large"
    >
      Event Live Blog
    </InfoItem.WithError>
  );
};

Item.Footer = ItemFooter;

export default Item;
